var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('p',{staticClass:"mb-0"},[_vm._v("Ocurrió un error de conexión")]),_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.reloadPage}},[_vm._v("Recargar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }